<template>
        <div class="card__container">
            <div class="addProject" @click="dropdownList">
                <div class="icon__after">
                    <i class="fas fa-sort"></i>
                </div>
                <span>{{list.title}}</span>
            </div>
            <ul v-if="showList">
                <li v-for="(item,index) in list.items" :key="index" @click="$emit('sort',item.key)">
                    {{item.name}}
                    <span class="icon"><Icon icon="swap"  color="#ffffff" :width="29" :height="21"/></span>           
                </li>

            </ul>
        </div>
</template>

<script>
import Icon from '../Icon.vue'
export default {
    components : { Icon },
    props : { 
        headerBackground : { type : String, default : "#333" },
        hoverColor  :{ type : String, default : "#3C66FF" },
        color : { type : String, default: "#ffffff"},
        backgroundColor : { type : String, dafault : "#ffffff"},
        // items : { type : Array, default : null}
    },
    data(){ 
        return { 
            showList : false,
            list : { 
                title : "sort by",
                items : [
                    { 
                        name : "date",
                        key : 'updated_at',
                    },
                    { 
                        name : "author",
                        key : 'author',
                    },
                    { 
                        name : "title",
                        key : 'title',
                    },
                ]
            }
        }
    },
     watch : { 
        "$store.state.modelOpened" (value) {
            if(!value) this.showList = false;
        },
    },
        methods : { 
            dropdownList() {
                this.showList = !this.showList;
                this.$store.state.modelOpened = true
            }
        }
}
</script>

<style lang="scss" scoped>
    .addProject {
      position: relative;
      text-decoration: none;
      text-transform: uppercase;
      background-color: #7367F0;
      box-shadow: 0 3px 6px 0 #7367f066;
      color: white;
      height: 4rem;
      display: var(--uismLinkDisplay);
      transition-duration: 0.4s;
      overflow: hidden;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin: 0 0.3rem;
      padding: 0.3rem 0.5rem;
      border-radius: 0.2rem;
      -webkit-transition: .3s;
      transition: .3s;
      font-weight: 700;
      cursor: pointer;

      i {
        margin-right: 5px;
      }
    }
    .card__container {
        width : auto;
        min-width: 12rem;
        position: relative;
        z-index: 3;
        text-transform: uppercase;
        font-weight: 900;
    }
    .title__bloc {
        display: flex;
        align-items: center;
        justify-content: start;
        background-color : #333a43;
        box-shadow: 0 3px 6px 0 #7367f066;
        color : #fff;
        width : 100%;
        padding: 1rem 1.5rem;
        font-weight: 400;
        font-size: 1.2rem;
        cursor: pointer;
        &:hover { 
            opacity: .9;
        }

        .icon__after{
            background-color: #4e68b0;
            box-shadow: 0 3px 6px 0 #7367f066;
            border-radius: 0.5rem;
            padding: 0.2rem 0.1rem;
            margin: 0 0.5rem;
            -webkit-box-shadow: 1px 2px 4px 0px #444444;
            box-shadow: 1px 2px 4px 0px #444444;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
        }
    }
    ul {
        list-style : none ;
        padding :  1rem;
        position : absolute;
        background-color: #ffffff;
        width : 100%;
        z-index: 2;
        border-radius:  0 0 1rem 1rem;
        box-shadow: 3px 5px 13px #e0e0e0;
        
    }
    li {
        font-weight: 400;
        position : relative;
        padding : .5rem 0;
        cursor: pointer;
        transition : .5s;
        text-transform: capitalize;
        display : flex;
        align-items : center;
        justify-content : space-between;
        &:after {
            content : "";
            position : absolute;
            border : 1px solid #f6f6f6;
            // border : 1px solid red;
            width : 90%;
            bottom : 0.4rem;
            left : 0;
            transition : .3s;
        }
        &:hover {
            color : #3C66FF;
            &:after {
                border-color : #3C66FF;
            }
        }
    }
  
    .icon {
        background-color: #3C66FF;
        border-radius: .5rem;
        padding : 0.2rem .1rem ;
        margin: 0 .5rem;
        display : flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: 0.1rem;
        z-index: 2;
    }

    @media  (max-width: 820px) {
        .card__container {
            width: 100%;
        }
        .title__bloc{
        padding: 1.3rem 2.5rem;
        // font-size: 0.9rem;
        justify-content: center;
        }  
    }
</style>


// WEBPACK FOOTER //
// src/components/global/sections/SortBy.vue